<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.data && state.contactData && state.isVisible"
       class="contact-box"
       data-cy="contact-box-in-cart"
  >
    <div class="contact-box-title"
         data-cy="contact-box-in-cart-title"
         [innerHTML]="(state.isUsOrCanada ? 'shared.contactBoxTitleUS' : 'shared.contactBoxTitle') | cxTranslate"
    ></div>

    <div *ngIf="state.isUsOrCanada && state.contactData.ordersEmail.length"
         class="contact-box-sub-header registration"
         data-cy="contact-box-in-cart-registration-title"
    >
      <b [innerHTML]="'shared.contactBoxTroubleWithPurchasing' | cxTranslate"></b>
    </div>
    <div *ngIf="state.contactData.ordersEmail.length">
      <img alt="email"
           class="contact-box-in-cart-icon"
           data-cy="contact-box-in-cart-orders-email-icon"
           src="assets/images/icon_envelope_brand_primary_color.svg"
           title="email"
      />
    </div>
    <div class="contact-line-orders-email">
      <mb-contact-box-line
              [text]="(state.isUsOrCanada ? 'shared.contactBoxCustomerServiceUS' : 'shared.contactBoxCustomerService') | cxTranslate"
              [value]="state.contactData.ordersEmail"
              [cmsLinkType]="cmsLinkType.EMAIL_LINK"
              inputType="mail"
              noLabel
      ></mb-contact-box-line>
    </div>
    <div *ngIf="state.showRequestEmail"
         class="contact-box-sub-header request"
         data-cy="contact-box-in-cart-request-header"
    >
      <b [innerHTML]="'shared.contactBoxQuestionsAroundQuotes' | cxTranslate"></b>
    </div>
    <div *ngIf="state.showRequestEmail"
         [class.d-none]="!state.contactData.ordersRequestEmail"
    >
      <img alt="email"
           class="contact-box-in-cart-icon"
           data-cy="contact-box-in-cart-orders-request-email-icon"
           src="assets/images/icon_envelope_brand_primary_color.svg"
           title="email"
      />
    </div>
    <div *ngIf="state.showRequestEmail"
         [class.d-none]="!state.contactData.ordersRequestEmail"
         class="contact-line-request-email"
    >
      <mb-contact-box-line [text]="'shared.contactBoxAccountManagement' | cxTranslate"
                           [value]="state.contactData.ordersRequestEmail"
                           [cmsLinkType]="cmsLinkType.EMAIL_LINK"
                           inputType="mail"
                           noLabel
                           tag="ordersRequestEmail"
      ></mb-contact-box-line>
    </div>
    <div *ngIf="state.isUsOrCanada && state.contactData.ordersPhone.trim().length"
         class="contact-box-sub-header phone"
         data-cy="contact-box-in-cart-phone-header"
    >
      <b [innerHTML]="'shared.hotline' | cxTranslate"></b>
    </div>
    <div *ngIf="state.contactData.ordersPhone.trim().length">
      <img alt="phone"
           class="contact-box-in-cart-icon phone"
           data-cy="contact-box-in-cart-phone-icon"
           src="assets/images/icon_phone_brand_primary_color.svg"
           title="phone"
      />
    </div>
    <div *ngIf="state.contactData.ordersPhone.trim().length"
         class="contact-line-orders-phone"
    >
      <mb-contact-box-line [text]="state.contactData.ordersPhone"
                           [cmsLinkType]="cmsLinkType.PHONE_LINK"
                           inputType="tel"
                           noLabel
                           tag="ordersPhone"
      ></mb-contact-box-line>
    </div>
    <ng-container *ngIf="!state.isUsOrCanada">
      <div>
        <img alt="location"
             data-cy="contact-box-in-cart-location-icon"
             src="assets/images/map_marker_brand_primary_color.svg"
             title="location"
        />
      </div>
      <div>
        <mb-contact-box-line [text]="state.contactData.company"
                             noLabel
                             tag="company"
        ></mb-contact-box-line>
        <mb-contact-box-line [text]="state.contactData.street"
                             noLabel
                             tag="street"
        ></mb-contact-box-line>
        <mb-contact-box-line [text]="state.contactData.cityAndZip"
                             noLabel
                             tag="cityAndZip"
        ></mb-contact-box-line>
        <mb-contact-box-line [text]="state.contactData.country"
                             tag="country"
                             noLabel
        ></mb-contact-box-line>
      </div>
    </ng-container>
  </div>
</ng-container>
